import { Box, Card, Divider, Stack } from '@mui/material'
import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  or,
  orderBy,
  query,
  where
} from 'firebase/firestore'
import { useEffect, useState } from 'react'
import AlgoliaLogo from '../../../Icons/algolia.png'
import algoliasearch from 'algoliasearch/lite'
import { Index, InstantSearch, SearchBox, useHits } from 'react-instantsearch'
import '../../../Style/Search.css'
import SearchResultTile, { SearchTileRow } from './SearchResultTile'
import WelcomeAlert from '../WelcomeAlert'
import Loading from '../../Helpers/Loading'

import BrandedSearch from '../../../Icons/document.jpg'

const Search = ({ uid, db, displayName }) => {
  const algoliaClient = algoliasearch(
    '5QYIIRZJEF',
    'b417e34e1db9887a2765845c18d1fc96'
  )

  const searchClient = {
    ...algoliaClient,
    search (requests) {
      if (requests.every(({ params }) => !params.query)) {
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
            processingTimeMS: 0,
            hitsPerPage: 0,
            exhaustiveNbHits: false,
            query: '',
            params: ''
          }))
        })
      }
      setLoading(false)
      return algoliaClient.search(requests)
    }
  }

  const [visited, setVisited] = useState([])
  const [yours, setYours] = useState([])
  const [popular, setPopular] = useState([])
  const [visitedPulse, setVisitedPulse] = useState([])
  const [yoursPulse, setYoursPulse] = useState([])
  const [popularPulse, setPopularPulse] = useState([])

  const [combinedVisited, setCombinedVisited] = useState([])
  const [combinedYours, setCombinedYours] = useState([])
  const [combinedPopular, setCombinedPopular] = useState([])

  const [loading, setLoading] = useState(true)
  const [queryText, setQueryText] = useState(false)

  const [showBM, setShowBM] = useState(true)

  useEffect(() => {
    const today = Date.now()

    const getDate = date => {
      return new Date(date.toDate())
    }

    const checkDates = document => {
      return (
        (document.visibleDate &&
          today >= getDate(document.visibleDate.startDate) &&
          today <= getDate(document.visibleDate.endDate)) ||
        document.uid === uid ||
        (document.admins && document.admins.includes(uid))
      )
    }

    const preSearchPulse = async () => {
      const userRef = await getDoc(doc(db, 'users', uid))
      if (userRef.exists()) {
        let data = userRef.data()
        let c = data.commentedOn ? data.commentedOn.reverse().slice(0, 10) : []
        let v = data.visited
          ? data.visited
              .reverse()
              .filter(val => !c.includes(val))
              .slice(0, 10)
          : []

        let c2 = []
        let v2 = []

        if (c.length > 0) {
          let q1 = query(collection(db, 'sliders'), where('__name__', 'in', c))
          const querySnapshot = await getDocs(q1)
          querySnapshot.forEach(doc => {
            let c_val = doc.data()
            c_val.id = doc.id
            checkDates(c_val) && c2.push(c_val)
          })
        }
        if (v.length > 0) {
          let q2 = query(collection(db, 'sliders'), where('__name__', 'in', v))
          const querySnapshot2 = await getDocs(q2)
          querySnapshot2.forEach(doc => {
            let v_val = doc.data()
            v_val.id = doc.id
            checkDates(v_val) && v2.push(v_val)
          })
        }
        setVisitedPulse([...c2, ...v2])

        let q3 = query(
          collection(db, 'sliders'),
          or(where('uid', '==', uid), where('admins', 'array-contains', uid)),
          orderBy('editDate', 'desc')
        )
        const querySnapshot3 = await getDocs(q3)
        let y2 = []
        querySnapshot3.forEach(doc => {
          let y_val = doc.data()
          y_val.id = doc.id
          y2.push(y_val)
        })
        setYoursPulse(y2)
      }

      let q4 = query(
        collection(db, 'sliders'),
        where('searchable', '==', true),
        orderBy('commentCount', 'desc'),
        limit(10)
      )
      const querySnapshot3 = await getDocs(q4)
      let p2 = []
      querySnapshot3.forEach(doc => {
        let p_val = doc.data()
        p_val.id = doc.id
        checkDates(p_val) && p2.push(p_val)
      })
      setPopularPulse(p2)
      setLoading(false)
    }

    const preSearch = async () => {
      const userRef = await getDoc(doc(db, 'users', uid))
      if (userRef.exists()) {
        let data = userRef.data()
        let c = data.commentedOn ? data.commentedOn.reverse().slice(0, 10) : []
        let v = data.visited
          ? data.visited
              .reverse()
              .filter(val => !c.includes(val))
              .slice(0, 10)
          : []

        let c2 = []
        let v2 = []

        if (c.length > 0) {
          let q1 = query(
            collection(db, 'documents'),
            where('__name__', 'in', c)
          )
          const querySnapshot = await getDocs(q1)
          querySnapshot.forEach(doc => {
            let c_val = doc.data()
            c_val.id = doc.id
            checkDates(c_val) && c2.push(c_val)
          })
        }
        if (v.length > 0) {
          let q2 = query(
            collection(db, 'documents'),
            where('__name__', 'in', v)
          )
          const querySnapshot2 = await getDocs(q2)
          querySnapshot2.forEach(doc => {
            let v_val = doc.data()
            v_val.id = doc.id
            checkDates(v_val) && v2.push(v_val)
          })
        }
        setVisited([...c2, ...v2])

        let q3 = query(
          collection(db, 'documents'),
          or(where('uid', '==', uid), where('admins', 'array-contains', uid)),
          orderBy('editDate', 'desc')
        )
        const querySnapshot3 = await getDocs(q3)
        let y2 = []
        querySnapshot3.forEach(doc => {
          let y_val = doc.data()
          y_val.id = doc.id
          y2.push(y_val)
        })
        setYours(y2)
      }

      let q4 = query(
        collection(db, 'documents'),
        where('searchable', '==', true),
        orderBy('commentCount', 'desc'),
        limit(10)
      )
      const querySnapshot3 = await getDocs(q4)
      let p2 = []
      querySnapshot3.forEach(doc => {
        let p_val = doc.data()
        p_val.id = doc.id
        checkDates(p_val) && p2.push(p_val)
      })
      setPopular(p2)
      setLoading(false)
    }

    if (uid) {
      preSearch()
      preSearchPulse()
    }
  }, [uid])

  useEffect(() => {
    let combinedVisitedArray = [...visited, ...visitedPulse]
    combinedVisitedArray.sort((a, b) => {
      if (a.editDate && b.editDate) {
        return b.editDate - a.editDate
      } else if (a.editDate) {
        return -1
      } else if (b.editDate) {
        return 1
      } else {
        return 0
      }
    })
    let combinedYoursArray = [...yours, ...yoursPulse]
    combinedYoursArray.sort((a, b) => {
      if (a.editDate && b.editDate) {
        return b.editDate - a.editDate
      } else if (a.editDate) {
        return -1
      } else if (b.editDate) {
        return 1
      } else {
        return 0
      }
    })
    let combinedPopularArray = [...popular, ...popularPulse]
    combinedPopularArray.sort((a, b) => {
      if (a.editDate && b.editDate) {
        return b.editDate - a.editDate
      } else if (a.editDate) {
        return -1
      } else if (b.editDate) {
        return 1
      } else {
        return 0
      }
    })
    setCombinedVisited(combinedVisitedArray)
    setCombinedYours(combinedYoursArray)
    setCombinedPopular(combinedPopularArray)
  }, [visited, yours, popular, visitedPulse, yoursPulse, popularPulse])

  return (
    <Card
      raised
      sx={{
        m: { md: 2, xs: 1 },
        mb: { md: 2, xs: 2 },
        mt: { md: 2, xs: 2 },
        minHeight: '95%',
        pb: 2
      }}
      className='searchPage'
    >
      <WelcomeAlert displayName={displayName} />
      <Stack
        direction='column'
        alignItems='center'
        spacing={2}
        sx={{ mb: 2, mt: 2 }}
      >
        <InstantSearch
          searchClient={searchClient}
          future={{ preserveSharedStateOnUnmount: false }}
          indexName='pulses'
        >
          <Box
            sx={{
              width: { xs: '100%', md: 'max(50%, 300px)' },
              pr: 2,
              pl: 2
            }}
          >
            <SearchBox
              classNames={{
                input: 'searchInput',
                submit: 'searchButton',
                form: 'searchForm',
                reset: 'searchReset',
                submitIcon: 'searchIcon'
              }}
              placeholder='Search'
              onSubmit={_e => {
                setLoading(true)
              }}
              onKeyDown={e => {
                if (
                  e.code === 'Backspace' &&
                  document.querySelector('.searchInput').value.length <= 1
                ) {
                  setQueryText(false)
                } else {
                  setQueryText(true)
                }
              }}
            />
          </Box>
          {queryText && (
            <h3>
              Search Results {'   '}
              <img
                src={AlgoliaLogo}
                alt='Search Powered by Algolia - Logo'
                style={{
                  height: '15px',
                  margin: '5px',
                  objectFit: 'contain',
                  verticalAlign: 'middle'
                }}
              />
            </h3>
          )}
          <Box
            sx={{
              display: 'flex',
              overflowX: 'auto',
              maxWidth: '90vw',
              paddingRight: 1,
              paddingTop: 2
            }}
          >
            <Index indexName='pulses'>
              {queryText && (
                <>
                  {loading ? (
                    <Loading padding='50px 0' />
                  ) : (
                    <CustomHits
                      db={db}
                      uid={uid}
                      setLoading={setLoading}
                      inLibrary={[
                        ...combinedVisited,
                        ...combinedPopular,
                        ...combinedYours
                      ].map(data => data.id)}
                      showBM={showBM}
                      setShowBM={setShowBM}
                      loading={loading}
                      index={'pulses'}
                    />
                  )}
                </>
              )}
            </Index>
            <Index indexName='documents'>
              {queryText == true && (
                <>
                  {loading ? (
                    <></>
                  ) : (
                    <CustomHits
                      db={db}
                      uid={uid}
                      setLoading={setLoading}
                      inLibrary={[
                        ...combinedVisited,
                        ...combinedPopular,
                        ...combinedYours
                      ].map(data => data.id)}
                      showBM={false}
                      setShowBM={setShowBM}
                      loading={loading}
                      index={'documents'}
                    />
                  )}
                </>
              )}
            </Index>
          </Box>
        </InstantSearch>

        {combinedYours.length > 0 && (
          <>
            {queryText == true && (
              <Divider component='div' sx={{ width: '75%' }} />
            )}
            <SearchTileRow documents={combinedYours} title={'Your Documents'} />
          </>
        )}

        {combinedVisited.length > 0 && (
          <>
            {(queryText == true || combinedYours.length > 0) && (
              <Divider component='div' sx={{ width: '75%' }} />
            )}
            <SearchTileRow
              documents={combinedVisited}
              title={'Recently Viewed'}
            />
          </>
        )}

        {combinedPopular.length > 0 && (
          <>
            <Divider component='div' sx={{ width: '75%' }} />
            <SearchTileRow documents={combinedPopular} title={'Popular'} />
          </>
        )}
      </Stack>
    </Card>
  )
}

function CustomHits ({
  db,
  uid,
  setLoading,
  inLibrary,
  showBM,
  setShowBM,
  index,
  loading
}) {
  const { hits: documentHits } = useHits({ indexName: index })

  if (documentHits.length > 0 && loading) {
    setLoading(false)
  }
  if (documentHits.length > 0) {
    setShowBM(false)
  } else {
    setShowBM(true)
  }

  return (
    <>
      {documentHits.length > 0 ? (
        documentHits.map(hit => (
          <SearchResultTile
            documentResult={hit}
            title={'your_search'}
            db={db}
            uid={uid}
            inLibrary={inLibrary}
            key={hit.path}
          />
        ))
      ) : showBM ? (
        <img
          src={BrandedSearch}
          alt='Collaborate'
          style={{ borderRadius: '4px', maxHeight: '200px' }}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export default Search
